// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ============================================================
   Shared auth-page design tokens & layout
   Used by: /pages/Login  +  /pages/ForgotPassword
   ============================================================ */
.auth-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  font-family: "Inter", sans-serif;
  background: #f8fafc;
  /* ----------------------------------------------- */
  /* Standalone (centered card — Login / Forgot PW)  */
  /* ----------------------------------------------- */
  /* ----------------------------------------------- */
  /* Split panels (Login page — legacy fallback)     */
  /* ----------------------------------------------- */
  /* ----------------------------------------------- */
  /* Form card                                       */
  /* ----------------------------------------------- */
  /* ----------------------------------------------- */
  /* Form controls (shared)                          */
  /* ----------------------------------------------- */
}
.auth-page--standalone {
  justify-content: center;
  align-items: center;
  background: radial-gradient(1000px 600px at 20% 0%, rgba(7, 93, 197, 0.12), transparent 60%), radial-gradient(800px 500px at 80% 100%, rgba(0, 65, 149, 0.1), transparent 60%), #f8fafc;
  padding: 32px 16px;
}
.auth-page__panel {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
.auth-page__panel--brand {
  flex: 0 0 46%;
  position: relative;
  background: radial-gradient(1200px 700px at 20% 0%, rgba(7, 93, 197, 0.25), transparent 60%), radial-gradient(900px 500px at 80% 100%, rgba(0, 65, 149, 0.22), transparent 60%), linear-gradient(135deg, #002a66 0%, #004195 55%, #075dc5 100%);
  overflow: hidden;
}
.auth-page__panel--brand::after {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 1px);
  background-size: 22px 22px;
  pointer-events: none;
  opacity: 0.6;
}
.auth-page__brand-inner {
  position: relative;
  z-index: 1;
  padding: 64px 56px;
  color: #ffffff;
  max-width: 480px;
}
.auth-page__logo-mark {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 36px;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.3);
}
.auth-page__logo-mark--small {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #eff6ff;
  border: 1px solid rgba(0, 65, 149, 0.15);
  margin: 0 auto 24px;
}
.auth-page__logo-accent {
  font-size: 28px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.5px;
}
.auth-page__logo-mark--small .auth-page__logo-accent {
  font-size: 20px;
  color: #004195;
}
.auth-page__brand-title {
  font-size: 44px;
  line-height: 1.1;
  font-weight: 700;
  margin: 0 0 18px;
  letter-spacing: -1px;
}
.auth-page__brand-sub {
  font-size: 17px;
  line-height: 1.6;
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-weight: 400;
}
.auth-page__panel--form {
  flex: 1 1;
  padding: 40px 32px;
  background: #f8fafc;
}
.auth-page--standalone {
  justify-content: center;
  background: radial-gradient(1000px 600px at 20% 0%, rgba(7, 93, 197, 0.12), transparent 60%), radial-gradient(800px 500px at 80% 100%, rgba(0, 65, 149, 0.1), transparent 60%), #f8fafc;
}
.auth-page__card {
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border-radius: 18px;
  padding: 44px 40px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 16px 48px -16px rgba(15, 23, 42, 0.12);
  border: 1px solid #e2e8f0;
  position: relative;
}
.auth-page__card--wide {
  max-width: 480px;
}
.auth-page__header {
  margin-bottom: 32px;
  text-align: left;
}
.auth-page__card--wide .auth-page__header {
  text-align: center;
}
.auth-page--standalone .auth-page__header {
  text-align: center;
}
.auth-page__title {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 8px;
  color: #0f172a;
  letter-spacing: -0.4px;
}
.auth-page__subtitle {
  font-size: 15px;
  line-height: 1.55;
  margin: 0;
  color: #64748b;
  font-weight: 400;
}
.auth-page__footer {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
  text-align: center;
}
.auth-page__footer-muted {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

.auth-form__item {
  margin-bottom: 20px;
  /* Hide Ant's default asterisk — we prefer labels clean */
}
.auth-form__item .ant-form-item-label > label {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
  letter-spacing: -0.1px;
}
.auth-form__item .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  display: none !important;
}
.auth-form__item .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
  display: none !important;
}
.auth-form__input .ant-input,
.auth-form__input .ant-input-affix-wrapper {
  height: 48px;
  border-radius: 8px;
  border: 1.5px solid #cbd5e1;
  background: #ffffff;
  padding: 0 14px;
  font-size: 15px;
  color: #0f172a;
  transition: all 180ms ease;
  box-shadow: none;
}
.auth-form__input .ant-input::placeholder,
.auth-form__input .ant-input-affix-wrapper::placeholder {
  color: #94a3b8;
  font-weight: 400;
}
.auth-form__input .ant-input:hover,
.auth-form__input .ant-input-affix-wrapper:hover {
  border-color: #075dc5;
}
.auth-form__input .ant-input:focus, .auth-form__input .ant-input.ant-input-focused, .auth-form__input .ant-input.ant-input-affix-wrapper-focused,
.auth-form__input .ant-input-affix-wrapper:focus,
.auth-form__input .ant-input-affix-wrapper.ant-input-focused,
.auth-form__input .ant-input-affix-wrapper.ant-input-affix-wrapper-focused {
  border-color: #004195;
  box-shadow: 0 0 0 4px rgba(0, 65, 149, 0.1);
}
.auth-form__input .ant-input-prefix {
  margin-right: 10px;
}
.auth-form__icon {
  color: #64748b;
}
.auth-form__forgot-row {
  display: flex;
  justify-content: flex-end;
  margin: -4px 0 24px;
}
.auth-form__forgot-link {
  font-size: 14px;
  font-weight: 600;
  color: #004195;
  text-decoration: none;
  transition: color 160ms ease;
}
.auth-form__forgot-link:hover {
  color: #075dc5;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.auth-form__submit-row {
  margin-top: 8px;
}
.auth-form__submit-btn {
  width: 100% !important;
  height: 48px !important;
  font-size: 16px !important;
  padding: 0 28px !important;
}

/* ----------------------------------------------- */
/* Back link (Forgot Password)                     */
/* ----------------------------------------------- */
.auth-back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  margin-bottom: 28px;
  background: none;
  border: none;
  cursor: pointer;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  transition: color 160ms ease, transform 160ms ease;
}
.auth-back-link:hover {
  color: #004195;
  transform: translateX(-2px);
}
.auth-back-link:focus-visible {
  outline: 2px solid #075dc5;
  outline-offset: 4px;
  border-radius: 4px;
}

/* ----------------------------------------------- */
/* Ant Design error state overrides                */
/* ----------------------------------------------- */
.auth-form .ant-form-item-has-error .ant-input,
.auth-form .ant-form-item-has-error .ant-input-affix-wrapper {
  border-color: #dc2626 !important;
}
.auth-form .ant-form-item-has-error .ant-input:focus, .auth-form .ant-form-item-has-error .ant-input.ant-input-focused, .auth-form .ant-form-item-has-error .ant-input.ant-input-affix-wrapper-focused,
.auth-form .ant-form-item-has-error .ant-input-affix-wrapper:focus,
.auth-form .ant-form-item-has-error .ant-input-affix-wrapper.ant-input-focused,
.auth-form .ant-form-item-has-error .ant-input-affix-wrapper.ant-input-affix-wrapper-focused {
  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.1) !important;
}

.auth-form .ant-form-item-explain-error {
  font-size: 13px;
  color: #dc2626;
  margin-top: 6px;
}

/* ----------------------------------------------- */
/* Disabled InvertFillButton override loading-look */
/* ----------------------------------------------- */
.invert-fill-btn:disabled {
  cursor: not-allowed !important;
  opacity: 0.72 !important;
  transform: none !important;
  box-shadow: none !important;
}

/* ----------------------------------------------- */
/* Responsive                                      */
/* ----------------------------------------------- */
@media (max-width: 960px) {
  .auth-page {
    flex-direction: column;
  }
  .auth-page__panel--brand {
    flex: 0 0 auto;
    min-height: 220px;
    width: 100%;
  }
  .auth-page__brand-inner {
    padding: 40px 28px;
    max-width: 100%;
  }
  .auth-page__brand-title {
    font-size: 30px;
  }
  .auth-page__brand-sub {
    font-size: 15px;
  }
  .auth-page__panel--form {
    padding: 28px 18px 40px;
    align-items: flex-start;
  }
  .auth-page__card {
    padding: 32px 24px;
    border-radius: 14px;
  }
  .auth-page__title {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;iEAAA;AAeA;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,gCAAA;EACA,mBARiB;EAUjB,oDAAA;EACA,oDAAA;EACA,oDAAA;EAWA,oDAAA;EACA,oDAAA;EACA,oDAAA;EAuGA,oDAAA;EACA,oDAAA;EACA,oDAAA;EA6DA,oDAAA;EACA,oDAAA;EACA,oDAAA;AAtLF;AAEE;EACE,uBAAA;EACA,mBAAA;EACA,uLACE;EAGF,kBAAA;AAHJ;AASE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAPJ;AAUE;EACE,aAAA;EACA,kBAAA;EACA,+OACE;EAGF,gBAAA;AAXJ;AAaI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,iFACE;EACF,0BAAA;EACA,oBAAA;EACA,YAAA;AAZN;AAgBE;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,cA1De;EA2Df,gBAAA;AAdJ;AAiBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,0BAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gDAAA;AAfJ;AAiBI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBArFa;EAsFb,wCAAA;EACA,mBAAA;AAfN;AAmBE;EACE,eAAA;EACA,gBAAA;EACA,cAxFe;EAyFf,sBAAA;AAjBJ;AAmBI;EACE,eAAA;EACA,cArGa;AAoFnB;AAqBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;AApBJ;AAuBE;EACE,SAAA;EACA,kBAAA;EACA,mBArHe;AAgGnB;AAwBE;EACE,uBAAA;EACA,uLACE;AAvBN;AA+BE;EACE,WAAA;EACA,gBAAA;EACA,mBArIe;EAsIf,mBAAA;EACA,kBAAA;EACA,sFACE;EAEF,yBAAA;EACA,kBAAA;AA/BJ;AAiCI;EACE,gBAAA;AA/BN;AAmCE;EACE,mBAAA;EACA,gBAAA;AAjCJ;AAmCI;EACE,kBAAA;AAjCN;AAoCI;EACE,kBAAA;AAlCN;AAsCE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAxKe;EAyKf,sBAAA;AApCJ;AAuCE;EACE,eAAA;EACA,iBAAA;EACA,SAAA;EACA,cA/Ke;EAgLf,gBAAA;AArCJ;AAwCE;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;AAtCJ;AAyCE;EACE,eAAA;EACA,cA5Le;EA6Lf,gBAAA;AAvCJ;;AAgDE;EACE,mBAAA;EAUA,yDAAA;AAtDJ;AA8CI;EACE,eAAA;EACA,gBAAA;EACA,cA7Ma;EA8Mb,kBAAA;EACA,sBAAA;AA5CN;AAgDI;EAEE,wBAAA;AA/CN;AAiDI;EAEE,wBAAA;AAhDN;AAqDI;;EAEE,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAhOa;EAiOb,eAAA;EACA,eAAA;EACA,cAtOa;EAuOb,0BAAA;EACA,gBAAA;AAnDN;AAqDM;;EACE,cAAA;EACA,gBAAA;AAlDR;AAqDM;;EACE,qBApPW;AAkMnB;AAqDM;;;;EAGE,qBA3PW;EA4PX,2CAAA;AAlDR;AAsDI;EACE,kBAAA;AApDN;AAwDE;EACE,cAhQe;AA0MnB;AAyDE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAvDJ;AA0DE;EACE,eAAA;EACA,gBAAA;EACA,cAlRe;EAmRf,qBAAA;EACA,4BAAA;AAxDJ;AA0DI;EACE,cAtRa;EAuRb,0BAAA;EACA,0BAAA;AAxDN;AA4DE;EACE,eAAA;AA1DJ;AA6DE;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;AA3DJ;;AA+DA,oDAAA;AACA,oDAAA;AACA,oDAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cA/SiB;EAgTjB,eAAA;EACA,gBAAA;EACA,kDAAA;AA5DF;AA8DE;EACE,cA3Te;EA4Tf,2BAAA;AA5DJ;AA+DE;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AA7DJ;;AAiEA,oDAAA;AACA,oDAAA;AACA,oDAAA;AAEE;;EAEE,gCAAA;AA/DJ;AAiEI;;;;EAGE,uDAAA;AA9DN;;AAmEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAhEF;;AAmEA,oDAAA;AACA,oDAAA;AACA,oDAAA;AACA;EACE,8BAAA;EACA,wBAAA;EACA,0BAAA;EACA,2BAAA;AAhEF;;AAmEA,oDAAA;AACA,oDAAA;AACA,oDAAA;AACA;EACE;IACE,sBAAA;EAhEF;EAkEE;IACE,cAAA;IACA,iBAAA;IACA,WAAA;EAhEJ;EAmEE;IACE,kBAAA;IACA,eAAA;EAjEJ;EAoEE;IACE,eAAA;EAlEJ;EAqEE;IACE,eAAA;EAnEJ;EAsEE;IACE,uBAAA;IACA,uBAAA;EApEJ;EAuEE;IACE,kBAAA;IACA,mBAAA;EArEJ;EAwEE;IACE,eAAA;EAtEJ;AACF","sourcesContent":["/* ============================================================\n   Shared auth-page design tokens & layout\n   Used by: /pages/Login  +  /pages/ForgotPassword\n   ============================================================ */\n\n$auth-navy:        #004195;\n$auth-navy-alt:    #075dc5;\n$auth-navy-soft:   #eff6ff;\n$auth-border:      #e2e8f0;\n$auth-border-2:    #cbd5e1;\n$auth-text:        #0f172a;\n$auth-text-muted:  #64748b;\n$auth-bg:          #f8fafc;\n$auth-white:       #ffffff;\n\n.auth-page {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  font-family: 'Inter', sans-serif;\n  background: $auth-bg;\n\n  /* ----------------------------------------------- */\n  /* Standalone (centered card — Login / Forgot PW)  */\n  /* ----------------------------------------------- */\n  &--standalone {\n    justify-content: center;\n    align-items: center;\n    background:\n      radial-gradient(1000px 600px at 20% 0%, rgba(7, 93, 197, 0.12), transparent 60%),\n      radial-gradient(800px 500px at 80% 100%, rgba(0, 65, 149, 0.10), transparent 60%),\n      $auth-bg;\n    padding: 32px 16px;\n  }\n\n  /* ----------------------------------------------- */\n  /* Split panels (Login page — legacy fallback)     */\n  /* ----------------------------------------------- */\n  &__panel {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n  }\n\n  &__panel--brand {\n    flex: 0 0 46%;\n    position: relative;\n    background:\n      radial-gradient(1200px 700px at 20% 0%, rgba(7, 93, 197, 0.25), transparent 60%),\n      radial-gradient(900px 500px at 80% 100%, rgba(0, 65, 149, 0.22), transparent 60%),\n      linear-gradient(135deg, #002a66 0%, #004195 55%, #075dc5 100%);\n    overflow: hidden;\n\n    &::after {\n      content: '';\n      position: absolute;\n      inset: 0;\n      background-image:\n        radial-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 1px);\n      background-size: 22px 22px;\n      pointer-events: none;\n      opacity: 0.6;\n    }\n  }\n\n  &__brand-inner {\n    position: relative;\n    z-index: 1;\n    padding: 64px 56px;\n    color: $auth-white;\n    max-width: 480px;\n  }\n\n  &__logo-mark {\n    width: 64px;\n    height: 64px;\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.12);\n    backdrop-filter: blur(8px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 36px;\n    box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.3);\n\n    &--small {\n      width: 48px;\n      height: 48px;\n      border-radius: 12px;\n      background: $auth-navy-soft;\n      border: 1px solid rgba(0, 65, 149, 0.15);\n      margin: 0 auto 24px;\n    }\n  }\n\n  &__logo-accent {\n    font-size: 28px;\n    font-weight: 800;\n    color: $auth-white;\n    letter-spacing: -0.5px;\n\n    .auth-page__logo-mark--small & {\n      font-size: 20px;\n      color: $auth-navy;\n    }\n  }\n\n  &__brand-title {\n    font-size: 44px;\n    line-height: 1.1;\n    font-weight: 700;\n    margin: 0 0 18px;\n    letter-spacing: -1px;\n  }\n\n  &__brand-sub {\n    font-size: 17px;\n    line-height: 1.6;\n    margin: 0;\n    color: rgba(255, 255, 255, 0.78);\n    font-weight: 400;\n  }\n\n  &__panel--form {\n    flex: 1;\n    padding: 40px 32px;\n    background: $auth-bg;\n  }\n\n  &--standalone {\n    justify-content: center;\n    background:\n      radial-gradient(1000px 600px at 20% 0%, rgba(7, 93, 197, 0.12), transparent 60%),\n      radial-gradient(800px 500px at 80% 100%, rgba(0, 65, 149, 0.10), transparent 60%),\n      $auth-bg;\n  }\n\n  /* ----------------------------------------------- */\n  /* Form card                                       */\n  /* ----------------------------------------------- */\n  &__card {\n    width: 100%;\n    max-width: 440px;\n    background: $auth-white;\n    border-radius: 18px;\n    padding: 44px 40px;\n    box-shadow:\n      0 1px 2px rgba(15, 23, 42, 0.04),\n      0 16px 48px -16px rgba(15, 23, 42, 0.12);\n    border: 1px solid $auth-border;\n    position: relative;\n\n    &--wide {\n      max-width: 480px;\n    }\n  }\n\n  &__header {\n    margin-bottom: 32px;\n    text-align: left;\n\n    .auth-page__card--wide & {\n      text-align: center;\n    }\n\n    .auth-page--standalone & {\n      text-align: center;\n    }\n  }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 1.2;\n    margin: 0 0 8px;\n    color: $auth-text;\n    letter-spacing: -0.4px;\n  }\n\n  &__subtitle {\n    font-size: 15px;\n    line-height: 1.55;\n    margin: 0;\n    color: $auth-text-muted;\n    font-weight: 400;\n  }\n\n  &__footer {\n    margin-top: 28px;\n    padding-top: 20px;\n    border-top: 1px solid $auth-border;\n    text-align: center;\n  }\n\n  &__footer-muted {\n    font-size: 13px;\n    color: $auth-text-muted;\n    line-height: 1.5;\n  }\n\n  /* ----------------------------------------------- */\n  /* Form controls (shared)                          */\n  /* ----------------------------------------------- */\n}\n\n.auth-form {\n  &__item {\n    margin-bottom: 20px;\n\n    .ant-form-item-label > label {\n      font-size: 14px;\n      font-weight: 600;\n      color: $auth-text;\n      margin-bottom: 8px;\n      letter-spacing: -0.1px;\n    }\n\n    /* Hide Ant's default asterisk — we prefer labels clean */\n    .ant-form-item-label >\n      label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n      display: none !important;\n    }\n    .ant-form-item-label >\n      label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {\n      display: none !important;\n    }\n  }\n\n  &__input {\n    .ant-input,\n    .ant-input-affix-wrapper {\n      height: 48px;\n      border-radius: 8px;\n      border: 1.5px solid $auth-border-2;\n      background: $auth-white;\n      padding: 0 14px;\n      font-size: 15px;\n      color: $auth-text;\n      transition: all 180ms ease;\n      box-shadow: none;\n\n      &::placeholder {\n        color: #94a3b8;\n        font-weight: 400;\n      }\n\n      &:hover {\n        border-color: $auth-navy-alt;\n      }\n\n      &:focus,\n      &.ant-input-focused,\n      &.ant-input-affix-wrapper-focused {\n        border-color: $auth-navy;\n        box-shadow: 0 0 0 4px rgba(0, 65, 149, 0.10);\n      }\n    }\n\n    .ant-input-prefix {\n      margin-right: 10px;\n    }\n  }\n\n  &__icon {\n    color: $auth-text-muted;\n  }\n\n  &__forgot-row {\n    display: flex;\n    justify-content: flex-end;\n    margin: -4px 0 24px;\n  }\n\n  &__forgot-link {\n    font-size: 14px;\n    font-weight: 600;\n    color: $auth-navy;\n    text-decoration: none;\n    transition: color 160ms ease;\n\n    &:hover {\n      color: $auth-navy-alt;\n      text-decoration: underline;\n      text-underline-offset: 2px;\n    }\n  }\n\n  &__submit-row {\n    margin-top: 8px;\n  }\n\n  &__submit-btn {\n    width: 100% !important;\n    height: 48px !important;\n    font-size: 16px !important;\n    padding: 0 28px !important;\n  }\n}\n\n/* ----------------------------------------------- */\n/* Back link (Forgot Password)                     */\n/* ----------------------------------------------- */\n.auth-back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  margin-bottom: 28px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: $auth-text-muted;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 160ms ease, transform 160ms ease;\n\n  &:hover {\n    color: $auth-navy;\n    transform: translateX(-2px);\n  }\n\n  &:focus-visible {\n    outline: 2px solid $auth-navy-alt;\n    outline-offset: 4px;\n    border-radius: 4px;\n  }\n}\n\n/* ----------------------------------------------- */\n/* Ant Design error state overrides                */\n/* ----------------------------------------------- */\n.auth-form .ant-form-item-has-error {\n  .ant-input,\n  .ant-input-affix-wrapper {\n    border-color: #dc2626 !important;\n\n    &:focus,\n    &.ant-input-focused,\n    &.ant-input-affix-wrapper-focused {\n      box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.10) !important;\n    }\n  }\n}\n\n.auth-form .ant-form-item-explain-error {\n  font-size: 13px;\n  color: #dc2626;\n  margin-top: 6px;\n}\n\n/* ----------------------------------------------- */\n/* Disabled InvertFillButton override loading-look */\n/* ----------------------------------------------- */\n.invert-fill-btn:disabled {\n  cursor: not-allowed !important;\n  opacity: 0.72 !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* ----------------------------------------------- */\n/* Responsive                                      */\n/* ----------------------------------------------- */\n@media (max-width: 960px) {\n  .auth-page {\n    flex-direction: column;\n\n    &__panel--brand {\n      flex: 0 0 auto;\n      min-height: 220px;\n      width: 100%;\n    }\n\n    &__brand-inner {\n      padding: 40px 28px;\n      max-width: 100%;\n    }\n\n    &__brand-title {\n      font-size: 30px;\n    }\n\n    &__brand-sub {\n      font-size: 15px;\n    }\n\n    &__panel--form {\n      padding: 28px 18px 40px;\n      align-items: flex-start;\n    }\n\n    &__card {\n      padding: 32px 24px;\n      border-radius: 14px;\n    }\n\n    &__title {\n      font-size: 24px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
